import "whatwg-fetch";

// forEach pollyfill
if (typeof NodeList.prototype.forEach !== "function") {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

export class Filters {
    constructor(filter) {
        this.dom = { el: filter };

        this.assign();
        this.events();
    }

    assign() {
        this.dom.labels = [...this.dom.el.querySelectorAll(".field label")];
        this.dom.refine_labels = [
            ...this.dom.el.querySelectorAll(".refine-label")
        ];
        this.dom.search = document.getElementById("live-search");
        this.dom.colour_count = document.querySelector("#colour-count");
        this.type = this._get_type(this.dom.el.dataset.refine);
        this.labelArray = [];
        this.inLabelArray = [];
        this.sLabelArray = [];
        this.eLabelArray = [];
        this.count = 0;
        this.scount = 0;
        this.ecount = 0;
        this.dcount = 0;

        this._no_items();
    }

    _up() {
        if (this.dom.el.dataset.refine === "edges") {
            this.ecount += 1;
            return this.ecount;
        }

        if (this.dom.el.dataset.refine === "sizing") {
            this.scount += 1;
            return this.scount;
        }

        if (
            this.dom.el.dataset.refine !== "edges" &&
            this.dom.el.dataset.refine !== "sizing"
        ) {
            this.count += 1;
            return this.count;
        }
    }

    _down() {
        if (this.dom.el.dataset.refine === "edges") {
            this.ecount -= 1;
            return this.ecount;
        }

        if (this.dom.el.dataset.refine === "sizing") {
            this.scount -= 1;
            return this.scount;
        }

        if (
            this.dom.el.dataset.refine !== "edges" &&
            this.dom.el.dataset.refine !== "sizing"
        ) {
            this.count -= 1;
            return this.count;
        }
    }

    _find_count(label) {
        if (label.parentNode.querySelector("input").checked) {
            label.classList.remove("selected");
            return this._down();
        } else {
            label.classList.add("selected");
            return this._up();
        }
    }

    _show_all(refineLabel) {
        let inputList = null;

        if (
            document.querySelector(".news-category-filter") ||
            document.querySelector(".showcase-category-filter")
        ) {
            inputList = [
                ...document.querySelectorAll(
                    `[data-refine] input:not(.refine-all)`
                )
            ];

            let labelList = [
                ...document.querySelectorAll(
                    `label:not(.refine-all-label):not(.form-label)`
                )
            ];

            labelList.map(label => {
                label.classList.remove("selected");
            });

            if (refineLabel) {
                refineLabel.innerHTML = `All categories`;
            }
        } else {
            inputList = [
                ...document.querySelectorAll(
                    `[data-refine="${
                        this.dom.el.dataset.refine
                    }"] input:not(.refine-all):not(.refine-s-all)`
                )
            ];

            if (refineLabel) {
                refineLabel.innerHTML = `${this.type}`;
            }
        }

        inputList.map(l => {
            l.checked = false;
        });

        if (this.dom.el.dataset.refine === "edges") {
            this.ecount = 0;
        } else if (this.dom.el.dataset.refine === "sizing") {
            this.scount = 0;
        } else {
            this.count = 0;
        }

        this._no_items();
    }

    _no_items() {
        const noItems = document.querySelector(".empty-state");

        if (noItems) {
            noItems.style.display = "none";
        }
    }

    _show_many(refineLabel, label, refineAll, refineSAll) {
        refineLabel.classList.add("active");

        document.querySelector(`input.refine-all`).checked = false;

        this.dcount = this._find_count(label);

        if (this.dcount === 0) {
            refineLabel.innerHTML = `${this.type}`;

            if (this.dom.el.dataset.refine === "edges") {
                refineAll.checked = true;
            }

            if (this.dom.el.dataset.refine === "sizing") {
                refineSAll.checked = true;
            }
        } else if (this.dcount === 1) {
            refineLabel.innerHTML = `1 ${this.type} selected`;

            if (this.dom.el.dataset.refine === "edges") {
                refineAll.checked = false;
            }

            if (this.dom.el.dataset.refine === "sizing") {
                refineSAll.checked = false;
            }
        } else if (this.dcount > 1) {
            if (
                document.querySelector(".news-category-filter") ||
                document.querySelector(".showcase-category-filter")
            ) {
                refineLabel.innerHTML = `${this.dcount} categories selected`;
            } else {
                refineLabel.innerHTML = `${this.dcount} ${this.type}s selected`;
            }
        }
    }

    _show(el) {
        const options = [...document.querySelectorAll(el)];

        options.map(option => {
            option.style.display = "block";
        });

        this._in_options_array();
    }

    _isHidden(el) {
        return (el.offsetParent === null)
    }

    events() {
        document.body.addEventListener("click", e => {
            if (
                e.target.classList &&
                !(
                    e.target.classList.contains("refine-dropdown") ||
                    e.target.classList.contains("refine-filters") ||
                    e.target.classList.contains("form-label") ||
                    e.target.classList.contains("js-custom-dropdown-click") ||
                    e.target.classList.contains("refine-all") ||
                    e.target.classList.contains("selected") ||
                    e.target.classList.contains("refine-label") ||
                    e.target.classList.contains("refine-all-label") ||
                    e.target.classList.contains("js-custom-dropdown") ||
                    e.target.type === "checkbox" ||
                    e.target.tagName === "LABEL"
                )
            ) {
                this._reset_filters();
            }
        });

        this.dom.refine_labels.map(rlabel => {
            rlabel.addEventListener("click", () => {
                rlabel.classList.toggle("active");
            });
        });

        if (this.dom.search) {
            this.dom.search.addEventListener("keyup", () => {
                this._filter(".showcase-item", this._value_function);
                this._filter(".news-list-item", this._value_news_function);
                this._filter(".resource-item", this._value_resource_function);

                if(this._count() === 0) {
                    const noItems = document.querySelector(".empty-state");

                    if (noItems) {
                        noItems.style.display = "block";
                    }
                } else {
                    this._no_items();
                }
            });
        }

        const showAllColours = document.getElementById("show-all");
        if (showAllColours) {
            showAllColours.addEventListener("click", e => {
                const refineLabel = this.dom.el.querySelector(".refine-label");
                let options = [...document.querySelectorAll(".grid-list-item")];

                if (options.length === 0) {
                    options = [...document.querySelectorAll(".news-list-item")];
                }

                options.map(option => {
                    option.style.display = "block";
                });

                this._show_all(refineLabel);
                this.dom.search.value = "";
            });
        }


        const products = [
            ...document.querySelectorAll("input[name='product-filter']")
        ];

        var currentProduct = "";

        if (products.length > 0) {

            products.map(product => {
                product.addEventListener("click", e => {

                    let productFor = product.id; //bestwood-melamine, bestwood-veneer etc // <label for="bestwood-melamine" />, 
                    var isChecked = false;
                    currentProduct = productFor;

                    for (var i = 0; i < products.length; i++) {

                        if (products[i].checked) {
                            isChecked = true;
                            if (currentProduct !== products[i].id) {
                                products[i].checked = false;
                            }
                        }
                    }


                    if (!isChecked) {
                        productFor = "";
                    }

                    if (product.id === productFor) {


                        let resourceAll = [
                            ...document.querySelectorAll(".resource-item")
                        ];

                        resourceAll.map(resource => {
                            if (
                                !resource.dataset.productcategory.includes(
                                    productFor
                                )
                            ) {
                                resource.style.display = "none";
                            } else {
                                resource.style.display = "block";
                            }
                        });
                    }
                    else {
                        let resourceAll = [
                            ...document.querySelectorAll(".resource-item")
                        ];

                        resourceAll.map(resource => {
                            resource.style.display = "block";
                        });
                    }
                });
            });
        }

        this.dom.labels.map(label => {
            label.addEventListener("click", e => {
                const refineLabel = this.dom.el.querySelector(".refine-label");
                const refineAll = this.dom.el.querySelector("input.refine-all");
                const refineSAll = this.dom.el.querySelector(
                    "input.refine-s-all"
                );

                refineLabel.classList.add("activated");

                if (label.classList.contains("refine-all-label")) {
                    this._show_all(refineLabel);
                } else {
                    this._show_many(refineLabel, label, refineAll, refineSAll);
                }

                if (label && label.classList.contains("refine-all-label")) {
                    let items = this._get_items();

                    items.map(option => {
                        option.style.display = "block";
                    });

                    if (this.type === "category" || this.type === "resource") {
                        this.inLabelArray = [];
                    } else {
                        if (this.type === "Edgetape") {
                            this.eLabelArray = [];
                        }

                        if (this.type === "sizing option") {
                            this.sLabelArray = [];
                        }
                    }
                } else {
                    if (this.type === "category" || this.type === "resource") {
                        this.labelArray = [
                            ...e.target.parentNode.parentNode.querySelectorAll(
                                `label:not(.refine-all-label):not(.form-label)`
                            )
                        ];

                        this.inLabelArray = this._in_array(this.labelArray);
                    } else {
                        this.eLabelArray = this._in_array([
                            ...document.querySelectorAll(
                                `[data-refine="edges"] label:not(.refine-all-label):not(.form-label)`
                            )
                        ]);

                        this.sLabelArray = this._in_array([
                            ...document.querySelectorAll(
                                `[data-refine="sizing"] label:not(.refine-all-label):not(.form-label)`
                            )
                        ]);
                    }

                    if (
                        document.querySelector(".technical-resources-filters")
                    ) {
                        this._show(".resource-item");
                    } else if (
                        document.querySelector(".showcase-category-filter")
                    ) {
                        this._show(".showcase-item");
                    } else if (
                        document.querySelector(".news-category-filter")
                    ) {
                        this._show(".news-list-item");
                    } else {
                        this._show(".swatch-grid .grid-list-item");
                    }
                }

                if (this.dom.colour_count) {
                    this.dom.colour_count.innerHTML = this._count();
                }

                const noItems = document.querySelector(".empty-state");

                if (noItems) {
                    if (this._count() > 0) {
                        noItems.style.display = "none";
                    } else {
                        noItems.style.display = "block";
                    }
                }
            });
        });
    }

    _value_function(single) {
        function _if_value(value) {
            return (
                value &&
                value.innerHTML
                    .toUpperCase()
                    .includes(
                        document
                            .getElementById("live-search")
                            .value.toUpperCase()
                    )
            );
        }

        if (
            _if_value(single.querySelector(".slide-caption p")) ||
            _if_value(single.querySelector(".subtitle")) ||
            _if_value(single.querySelector(".heading a"))
        ) {
            return false;
        } else {
            return true;
        }
    }

    _value_resource_function(single) {
        function _if_value(value) {
            return (
                value &&
                value.innerHTML
                    .toUpperCase()
                    .includes(
                        document
                            .getElementById("live-search")
                            .value.toUpperCase()
                    )
            );
        }

        if (
            _if_value(single.querySelector("p")) ||
            _if_value(single.querySelector(".heading"))
        ) {
            return false;
        } else {
            return true;
        }
    }

    _value_news_function(single) {
        function _if_value(value) {
            return (
                value &&
                value.innerHTML
                    .toUpperCase()
                    .includes(
                        document
                            .getElementById("live-search")
                            .value.toUpperCase()
                    )
            );
        }

        if (
            _if_value(single.querySelector(".news-date")) ||
            _if_value(single.querySelector(".text")) ||
            _if_value(single.querySelector(".news-category")) ||
            _if_value(single.querySelector(".news-heading a"))
        ) {
            return false;
        } else {
            return true;
        }
    }

    _filter(el, valueFunction) {
        const showcase = [...document.querySelectorAll(el)];
        if (showcase.length > 0) {
            if (this.dom.search.value.length > 0) {
                this._show(".showcase-item");

                showcase.map(single => {
                    if (valueFunction(single)) {
                        single.style.display = "none";
                    }
                });
            } else {
                let items = this._get_items();

                items.map(option => {
                    option.style.display = "block";
                });
                this.labelArray = [
                    ...document.querySelectorAll(
                        `label:not(.refine-all-label):not(.form-label)`
                    )
                ];
                this.inLabelArray = this._in_array(this.labelArray);
                this._show(el);
            }

            // this._show_none([...document.querySelectorAll(el)]);
        }
    }

    _in_array(labels) {
        let optionsArray = [];

        labels.map(l => {
            if (l.classList && l.classList.contains("selected")) {
                optionsArray.push(l.htmlFor.split("_")[1]);
            }
        });

        return optionsArray;
    }

    _is_displayed(element) {
        return (element.currentStyle
            ? element.currentStyle.display
            : getComputedStyle(element, null).display) === `block`
            ? true
            : false;
    }

    _get_items() {
        let items = [
            ...document.querySelectorAll(`.grid-list .grid-list-item`)
        ];

        if (items.length === 0) {
            items = [...document.querySelectorAll(`.news-list-item`)];
        }

        return items;
    }

    _in_options_array() {
        let gridItems = this._get_items();

        gridItems.map(item => {
            item.style.display = "block";
        });

        gridItems.map(item => {
            if (this.inLabelArray.length > 0) {
                this.inLabelArray.map(label => {
                    if (item.dataset.category !== undefined) {
                        if (!item.dataset.category.includes(label)) {
                            item.style.display = "none";
                        }
                    }

                    if (item.dataset.documenttype !== undefined) {
                        if (!item.dataset.documenttype.includes(label)) {
                            item.style.display = "none";
                        }
                    }
                });
            }

            if (this.eLabelArray.length > 0) {
                this.eLabelArray.map(label => {
                    if (
                        item.dataset.edges !== undefined &&
                        !item.dataset.edges.includes(label)
                    ) {
                        item.style.display = "none";
                    }
                });
            }
            if (this.sLabelArray.length > 0) {
                this.sLabelArray.map(label => {
                    if (
                        item.dataset.sizes !== undefined &&
                        !item.dataset.sizes.includes(label)
                    ) {
                        item.style.display = "none";
                    }
                });
            }
        });
    }

    _get_type(dataRefine) {
        const refineAllL = this.dom.el.querySelector("label.refine-all-label");
        let type = `${dataRefine === "edges" ? "Edgetape": dataRefine}`;

        if (
            document.querySelector(".news-category-filter") ||
            document.querySelector(".showcase-category-filter")
        ) {
            type = "category";
        }

        if (refineAllL && refineAllL.classList.contains("refine-r-all-label")) {
            type = `resource`;
        }

        return type;
    }

    _reset_filters() {
        document.querySelectorAll(".refine-label").forEach(l => {
            l.classList.remove("active");
        });
    }

    _count() {
        let count = 0;

        let list = [
            ...document.querySelectorAll(".swatch-grid .grid-list-item")
        ];

        if (list.length === 0) {
            list = [...document.querySelectorAll(".news-list-item")];
        }

        if (list.length === 0) {
            list = [...document.querySelectorAll(".resource-item")];
        }

        if (list.length === 0) {
            list = [...document.querySelectorAll(".showcase-item")];
        }

        if (list) {
            list.map(div => {
                if (this._is_displayed(div)) {
                    count += 1;
                }
            });
        }

        return count;
    }
}
